import React from "react";
import { FaCheck } from "react-icons/fa";
import styled from "styled-components";

import colors from "../../../styles/colors";

const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 0.1rem;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 0.1rem;
`;

interface IStyledCheckboxProps {
  checked?: boolean;
}

const StyledCheckbox = styled.div<IStyledCheckboxProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  background: ${props => (props.checked ? colors.buttonBlue : colors.white)};
  border: 0.1rem solid ${props => (props.checked ? colors.buttonBlue : colors.black)};
  border-radius: 0.3rem;
  transition: all 150ms;
  text-align: center;
  cursor: pointer;
  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 0.3rem black;
  }

  :hover {
    opacity: 0.7;
  }
`;

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

interface ICustomProps {
  customChecked?: boolean;
}

type CheckBoxProps = ICustomProps & React.HTMLProps<HTMLInputElement>;

const CheckBox: React.FC<CheckBoxProps> = React.forwardRef((props, ref) => {
  const [checked, setChecked] = React.useState(props.defaultChecked);
  const isChecked = props.customChecked ?? checked;
  const onChange: React.HTMLProps<HTMLInputElement>["onChange"] = e => {
    props.onChange?.(e);
    setChecked(!checked);
  };
  return (
    <label>
      <CheckboxContainer>
        <HiddenCheckbox name={props.name} checked={isChecked} onChange={onChange} ref={ref} />
        <StyledCheckbox checked={isChecked}>{isChecked && <FaCheck color="white" />}</StyledCheckbox>
      </CheckboxContainer>
      {props.children}
    </label>
  );
});

export default CheckBox;
